import { Config } from '@leverege/plugin';
import MoltenUtil from "../MoltenUtil.js";
import Constants from "../Constants.js"; // import GroupScreen from '../screens/group/GroupScreen'
// import ItemScreen from '../screens/item/ItemScreen'
// import ItemInfoScreen from '../screens/itemInfo/ItemInfoScreen'
import Relationship from "./Relationship.js"; // import SimpleSearchScreen from '../screens/simpleSearch/SimpleSearchScreen'
import ImagineRelationship from "./dataSource/ImagineRelationship.js"; // import MissingRelationshipScreen from '../screens/support/MissingRelationshipScreen'
/**
 * 
 */
async function run(molten, blueprints) {
  if (blueprints == null || blueprints.length === 0) {
    return;
  }
  const options = {
    // TODO: Add these to config somehow without being incredibly annoying?
    groupScreen: Config.get('BlueprintRoutes', 'groupScreen', molten.getDefault('BlueprintRoutes', 'groupScreen')),
    simpleSearchScreen: Config.get('BlueprintRoutes', 'simpleSearchScreen', molten.getDefault('BlueprintRoutes', 'simpleSearchScreen')),
    itemScreen: Config.get('BlueprintRoutes', 'itemScreen', molten.getDefault('BlueprintRoutes', 'itemScreen')),
    infoScreen: Config.get('BlueprintRoutes', 'infoScreen', molten.getDefault('BlueprintRoutes', 'infoScreen')),
    missingRelScreen: Config.get('BlueprintRoutes', 'missingRelScreen', molten.getDefault('BlueprintRoutes', 'missingRelScreen')),
    baseUrl: Config.get('BlueprintRoutes', 'baseUrl', molten.getConfig('personaUrl', '/p/:persona')),
    rootClient: Config.get('BlueprintRoutes', 'rootClient', 'Main'),
    systemId: molten.getConfig('api/systemId'),
    typeMap: blueprints[0].blueprints,
    blueprints
  };
  const phases = ['setup', 'run'];
  for (let pn = 0; pn < phases.length; pn++) {
    const phase = phases[pn];
    for (let n = 0; n < blueprints.length; n++) {
      const blueprint = blueprints[n];

      // Root level things are all one to manys
      const relationship = new ImagineRelationship({
        path: blueprint.type,
        objectType: blueprint.type,
        systemId: options.systemId,
        refPath: `:systemId/${blueprint.type}`,
        urlPath: `${options.baseUrl}/${blueprint.type}`,
        parentBlueprint: null,
        blueprint,
        attribute: null,
        chain: [blueprint]
      });
      // eslint-disable-next-line no-await-in-loop
      await process(molten, relationship, options, phase);
    }
  }
}

// Process the attributes of a the current blueprint
async function processAttributes(molten, rel, options, phase) {
  const {
    blueprint
  } = rel;
  for (let n = 0; n < blueprint.attributes.length; n++) {
    const attr = blueprint.attributes[n];
    if (!attr.isRelationship() || !attr.targetBlueprint) {
      continue;
    }
    // const next = rel.isGroup ? `:${rel.blueprint.type}Id/${attr.path}` : attr.path
    const relationship = rel.createChild(attr.path, {
      name: attr.name,
      objectType: attr.targetBlueprint.type,
      relationshipType: attr.relationshipType,
      systemId: rel.systemId,
      parentBlueprint: rel.blueprint,
      blueprint: attr.targetBlueprint,
      attribute: attr,
      chain: [...rel.chain, attr]
    });

    // eslint-disable-next-line no-await-in-loop
    await process(molten, relationship, options, phase);
  }
}
async function process(molten, relationship, options, phase) {
  if (phase === 'setup') {
    Relationship.add(relationship);
  } else {
    await MoltenUtil.invokeMoltenCallbacks(Constants.BLUEPRINT_RELATIONSHIP_PROCESSOR, 'processRelationship', molten, relationship, options);
  }
  return processAttributes(molten, relationship, options, phase);
}
export default {
  run
};